import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render() {
        return (<ga-events />);
    }

    componentDidMount() {
        const component = this;

        $(document).on(
            'click',
            [
                'a[data-ga-event]',
                '[data-ga-event][class^="button"]',
                '[data-ga-event][data-action^="Click"]',
            ].join(', '),
            function() { component.trackDynamicClick(this); }
        );

        $(document).on('click', '.over-shadow.dim:not(.js-mobile_nav)', function() {
            component.props.trackEvent(['Navigation', 'Close', 'Background']);
        });

        $(document).on(
            'input',
            '[data-ga-event][data-action^="Type"], [data-ga-event][data-action^="Input"]',
            function () { component.trackOneTimeEvent($(this)); }
        );

        $(document).on(
            'change',
            '[data-ga-event][data-action^="Select"]',
            function () { component.trackOneTimeEvent($(this)); }
        );

        $(document).on('click', '.js-footer-links a', function() {
            component.props.trackEvent(['Footer', 'Click', $(this).text()]);
        });

        $(document).on('click', '.js-trackable_nav a', function () {
            component.trackBubbledLink($(this), 'Navigation', 'Click');
        });
    }

    trackDynamicClick(el) {
        const category = $(el).data('category');
        const action = $(el).data('action');
        const label = $(el).data('label');

        if (category && label) {
            this.props.trackPromo([category, label]);

            if (action) {
                this.props.trackEvent([category, action, label]);
            }
        }
    }

    trackOneTimeEvent($el) {
        this.props.trackEvent([ $el.data('category'), $el.data('action'), $el.data('label') ]);

        // both must be removed for .data() to stop returning values
        $el.removeAttr('data-ga-event data-action data-category data-label');
        $el.removeData('ga-event action category label');
    }

    trackBubbledLink($a, category, action) {
        if ($a.is('a[data-ga-event]')) {
            return;
        }

        const label_parts = [];
        const label_prefix = $a.parents('[data-ga-event]').data('label-prefix');
        if (label_prefix) {
            label_parts.push(label_prefix);
        }

        label_parts.push($a.text().trim().replace(/\s+/g, ' '));

        const label_suffix = $a.parents('[data-ga-event]').data('label-suffix');
        if (label_suffix) {
            label_parts.push(label_suffix);
        }

        const label = label_parts.join(' - ');

        this.props.trackPromo([category, label]);
        this.props.trackEvent([category, action, label]);
    }
}

const mapDispatchToProps = (dispatch) => ({
    trackEvent: data => dispatch({ type: 'ga:event', payload: data }),
    trackPromo: payload => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(null, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/ga-events.js